import QRCode from "react-qr-code";
import React, { useState, useEffect } from 'react';

const DepositModal = ({ data, coin, onClose }) => {

const address = data.address_in;
const session = data.session_id;

const network = coin.external_key.split("_")[0].toUpperCase();

const [copied, setCopied] = React.useState(false);

const copyAddress = () => {
    navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(()=>setCopied(false),2000);
};

return (

<div className="deposit-modal-overlay">

<div className="deposit-modal">

<div className="deposit-modal-header">

<div className="deposit-header-left">

<div className="deposit-header-icon">

<svg
width="16"
height="16"
viewBox="0 0 24 24"
fill="none"
stroke="currentColor"
strokeWidth="2"
strokeLinecap="round"
strokeLinejoin="round"
>

<path d="M12 5v14"/>
<path d="M19 12l-7 7-7-7"/>

</svg>

</div>

<div className="deposit-header-text">

<div className="deposit-header-title">
Crypto Deposit
</div>

<div className="deposit-header-sub">
Send {coin.ticker.toUpperCase()} to your wallet
</div>

</div>

</div>

<button onClick={onClose} className="deposit-close">
✕
</button>

</div>


<div className="deposit-modal-body">

<div className="deposit-coin">

<img src={coin.logo} className="deposit-logo" />

<div>
<div className="deposit-coin-name">
{coin.coin.toUpperCase()}
</div>

<div className="deposit-network">
Network:  <span className="crypto-network-badge">{network}</span>
</div>
</div>

</div>


<div className="deposit-qr">

<QRCode value={address} size={180} />

</div>


<div className="deposit-minimum">

    <div className="deposit-minimum-header">

    <span>Minimum deposit</span>

    <span className="deposit-min-value">
    {coin.minimum_transaction_coin} {coin.ticker.toUpperCase()}
    </span>

    </div>

    <div className="deposit-min-bar">

    <div
    className="deposit-min-bar-fill"
    style={{width:"35%"}}
    />

    </div>

</div>


<div className="deposit-address">

{/* <div className="deposit-label">
Deposit Address
</div> */}

<div className="deposit-address-box">

<input
value={address}
readOnly
/>

<button onClick={copyAddress}>
    {copied ? "✓ Copied" : "Copy"}
</button>

</div>

</div>


<div className="deposit-session">

Session ID

<div className="deposit-session-id">
{session}
</div>

</div>


<div className="deposit-warning">

Send only {coin.coin.toUpperCase()} via {network} network

</div>


</div>

</div>

</div>

);
};

export default DepositModal;